<mat-card class=" ">
    <mat-card-header class="titreFrm">
        <mat-card-title>SALLES / ATELIERS</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <form class="example-form" #form="ngForm">
            <!-------------------- bouton -->
            <div class="btn">
                <div class="button-row">
                    <button  [disabled]="disabled" (click)="retourListes()" mat-raised-button class="colorGreen">
                        <mat-icon>format_list_bulleted</mat-icon>
                        Liste des salles/ateliers
                    </button>
                </div>
                <div class="button-row">
                    <button [disabled]="disabledBtnEnregistrer || disabled" (click)="enregistrer(form)"  mat-raised-button class="colorGreen">
                        <mat-icon>save</mat-icon>
                        Enregistrer
                    </button>
                </div>
                
            </div>
            <mat-tab-group #tabGroupe [(selectedIndex)]="index" (selectedTabChange)="tabChanged($event)">
                <!--------------------Informations Salles ------------>
                <mat-tab label="Informations">
                    <br>
                    <div class="displayFlex">
                        <mat-card class="cardInformaton" style="width: 270px;">
                            <mat-card-content>
                                <h6>Caractéristiques</h6>
                                <mat-form-field     appearance="outline"  style="width: 200px;">
                                    <mat-label>Type salle</mat-label>
                                    <mat-select [disabled]="disabled" name="Machine_Type" #Machine_Type="ngModel"
                                        [(ngModel)]="salle.Machine_Type" placeholder="Type salle" required>
                                        <mat-option *ngFor="let salle of listeAllSalle" [value]="salle.DiverSys_Index">
                                            {{salle.DiverSys_Titre}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="cardInformaton" style="width: 600px;">
                            <mat-card-content>
                                <h6>Renseignements</h6>
                                <mat-form-field     appearance="outline"  style="width: 50px;">
                                    <mat-label>N°porte</mat-label>
                                    <input placeholder="N°porte" [disabled]="disabled"  #Machine_Emp2="ngModel" matInput name="Machine_Emp2" [(ngModel)]="salle.Machine_Emp2">
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  style="width: 200px;">
                                    <mat-label>Bâtiment</mat-label>
                                    <mat-select [disabled]="disabled" name="Machine_CapTemps" #Machine_Type="ngModel"
                                        [(ngModel)]="salle.Machine_CapTemps" placeholder="Bâtiment" required>
                                        <mat-option *ngFor="let salle of listeAllBloque" [value]="salle.DiverSys_Index">
                                            {{salle.DiverSys_Titre}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  style="width: 50px;">
                                    <mat-label>Étage</mat-label>
                                    <input placeholder="Étage" [disabled]="disabled"  #Machine_Fournisseur="ngModel"  matInput name="Machine_Fournisseur" [(ngModel)]="salle.Machine_Fournisseur">
                                </mat-form-field>
                                <mat-form-field     appearance="outline"  style="width: 70px;">
                                    <mat-label>Nbr place</mat-label>
                                    <input placeholder="Nbr place" type="number" [disabled]="disabled"  #Machine_TR="ngModel"  matInput name="Machine_TR" [(ngModel)]="salle.Machine_TR">
                                </mat-form-field>      
                            </mat-card-content>
                        </mat-card>   
                    </div>
                     <mat-card *ngIf="typeTrs != '1'" class="cardInformaton">
                        <mat-card-content>   
                            <div>
                                <app-avt-listes #listeMachineComponen [showFilter]="false" [heightTable]="'300'" [dataSourceBrut]="datasourceMachine" [displayedColumnsBrut]="columnsMachine" [listBtn]="listBtnMachine" (btnTable)="clickBtnHeat($event)"></app-avt-listes>
                            </div>   
                        </mat-card-content>
                    </mat-card>   
                </mat-tab>
                <mat-tab label="Commentaires">
                    <!-- Angular Editor Supprimer -->
                    <!-- <angular-editor [config]="editorConfig" placeholder=" " name="Machine_CompteurUnite" #Machine_CompteurUnite="ngModel" [(ngModel)]="salle.Machine_CompteurUnite"></angular-editor> -->
                </mat-tab>
                <mat-tab label="Documents">
                    <div *ngIf="showDoc">
                        <app-show-tree-doc [param_code]="salle.avtSalle" [File_Type]="'collaborateur'" [typeTrs]="typeTrs">
                        </app-show-tree-doc>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </form>
    </mat-card-content>
</mat-card>